export function dateStyle(dateStr) {
  if (typeof dateStr !== "string") {
    return "";
  }
  const onlyDate = dateStr.split(/[T ]/)[0];
  return onlyDate.replace(/[/-]/g, ".");
}

export function formatNumberShort(value) {
  const n = Number(value);
  if (isNaN(n)) return value;
  if (Math.abs(n) < 1000) return String(value);
  const i = Math.trunc(n);
  const sign = i < 0 ? "-" : "";
  const absI = Math.abs(i);
  const fmt = (num) => {
    const s = num.toFixed(2);
    const cleaned = s.replace(/\.?0+$/, "");
    return cleaned.replace(".", ",");
  };
  if (absI >= 1_000_000_000_000) return sign + fmt(absI / 1_000_000_000_000) + "T";
  if (absI >= 1_000_000_000) return sign + fmt(absI / 1_000_000_000) + "B";
  if (absI >= 1_000_000) return sign + fmt(absI / 1_000_000) + "M";
  return sign + fmt(absI / 1000) + "K";
}
